// extracted by mini-css-extract-plugin
module.exports = {"container":"FuwDevice_container__peYof","wrapper":"FuwDevice_wrapper__2a0lx","icon":"FuwDevice_icon__1gacn","shrink":"FuwDevice_shrink__2va_6","title":"FuwDevice_title__3PQj-"};